import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiWrapper } from "../apis/CommonApi";
import * as accountApi from "../apis/AccountApi";
import PageHeader from "../components/PageHeader";

export default function FindIdPasswordPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [selectedTab, setSelectedTab] = useState("id");

  useEffect(() => {
    setFormDataProperty("userName", "");
    setFormDataProperty("phoneNumber1", "");
    setFormDataProperty("email1", "");
    setFormDataProperty("userId", "");
    setFormDataProperty("phoneNumber2", "");
    setFormDataProperty("email2", "");
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleSubmitFindId = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const { userName, phoneNumber1, email1 } = formData;
        const { status, data } = await accountApi.findUserId(
          userName,
          phoneNumber1,
          email1
        );
        if (data) {
          //navigate("/find-id-password/complete/");
          alert(`${data}`);
        }
      });
    }
  };

  const handleSubmitFindPassword = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const { userId, phoneNumber2, email2 } = formData;
        const { status, data } = await accountApi.findPassword(
          userId,
          phoneNumber2,
          email2
        );
        if (data) {
          alert(`${data}`);
        }
      });
    }
  };

  const handleTabClick = (tabId) => {
    setSelectedTab(tabId);
  };

  return (
    <section class="mbSection">
      <PageHeader isBlack={false} title="아이디/비밀번호 찾기" isUseMenu={false} />
      <div class="container">
        <div class="tab-menu">
          <button
            type="button"
            className={`tab-btn ${selectedTab === "id" ? "active" : ""}`}
            data-tab="tab-id"
            onClick={() => handleTabClick("id")}
          >
            아이디 찾기
          </button>
          <button
            type="button"
            className={`tab-btn ${selectedTab === "password" ? "active" : ""}`}
            data-tab="tab-pw"
            onClick={() => handleTabClick("password")}
          >
            비밀번호 찾기
          </button>
        </div>

        {formData && (
          <>
            {selectedTab === "id" && (
              <form onSubmit={handleSubmitFindId}>
                <div class="tab-content" id="tab-id">
                  <div class="input-wrap input-join-wrap">
                    <div class="input-item">
                      <p class="input-title">사용자 이름</p>
                      <div class="input-inner-wrap">
                        <input
                          class="defaultInput"
                          type="text"
                          placeholder="사용자 이름을 입력해주세요."
                          name="userName"
                          value={formData.userName}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                    <div class="input-item">
                      <p class="input-title">휴대폰 번호</p>
                      <div class="input-inner-wrap">
                        <input
                          class="defaultInput"
                          type="text"
                          placeholder="휴대폰 번호를 입력해주세요."
                          name="phoneNumber1"
                          value={formData.phoneNumber1}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                    <div class="input-item">
                      <p class="input-title">이메일</p>
                      <div class="input-inner-wrap">
                        <input
                          class="defaultInput"
                          type="text"
                          placeholder="이메일을 입력해주세요."
                          name="email1"
                          value={formData.email1}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="btm-fixed-wrap">
                    <div class="guide-wrap">
                      <p class="guide-txt">
                        가입하신 회원 정보와 일치할 경우 <br />
                        이메일로로 아이디를 보내 드립니다.
                      </p>
                    </div>
                    <button type="submit" class="btn btn-black-round">
                      아이디 찾기
                    </button>
                  </div>
                </div>
              </form>
            )}

            {selectedTab === "password" && (
              <form onSubmit={handleSubmitFindPassword}>
                <div class="tab-content" id="tab-pw">
                  <div class="input-wrap input-join-wrap">
                    <div class="input-item">
                      <p class="input-title">아이디</p>
                      <div class="input-inner-wrap">
                        <input
                          class="defaultInput"
                          type="text"
                          placeholder="아이디를 입력해주세요."
                          name="userId"
                          value={formData.userId}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                    <div class="input-item">
                      <p class="input-title">휴대폰 번호</p>
                      <div class="input-inner-wrap">
                        <input
                          class="defaultInput"
                          type="text"
                          placeholder="휴대폰 번호를 입력해주세요."
                          name="phoneNumber2"
                          value={formData.phoneNumber2}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                    <div class="input-item">
                      <p class="input-title">이메일</p>
                      <div class="input-inner-wrap">
                        <input
                          class="defaultInput"
                          type="text"
                          placeholder="이메일을 입력해주세요."
                          name="email2"
                          value={formData.email2}
                          onChange={onChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div class="btm-fixed-wrap">
                    <div class="guide-wrap">
                      <p class="guide-txt">
                        가입하신 회원 정보와 일치할 경우 <br />
                        이메일로 비밀번호를 보내 드립니다.
                      </p>
                    </div>
                    <button class="btn btn-black-round btm-fixed">
                      비밀번호 찾기
                    </button>
                  </div>
                </div>
              </form>
            )}
          </>
        )}
      </div>
    </section>
  );
}
